// extracted by mini-css-extract-plugin
export default {"Tabs_stats_modal":"jCZIBf6WEKfWYe43Z_JI","Tabs_modal_form_note":"gKWbGPLGZ8GXTf8gSdVx"};